import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Print
const createPrinter = (data) => {
    return http.post("/Printer/InsertPrinter", data);
};

const getPrinter = (data) => {
    return http.post("/Printer/FilterPrinter", data);
};

const updatePrinter = (data) => {
    return http.post("/Printer/UpdatePrinter", data);
};

export default {
    createPrinter,
    getPrinter,
    updatePrinter
};
